export default __webpack_public_path__ + "static/media/close-active.b0a11703.svg";